<template>
    <MobileTopBar :with_logo="true"/>
    <div class="container">
<!--        <div class="mb-5 md:mb-10">-->
<!--            <HomeSlider/>-->
<!--        </div>-->
        <OnlyMobile>
            <MobileCategoriesNav/>
        </OnlyMobile>
        <div class="md:mb-10">
            <PopularProductBanners/>
        </div>
        <div class="mb-10" v-if="!themeStore.minimize_ui">
            <SearchByPhotoBanner/>
        </div>
        <!--    <HomeCatalogNavigation/>-->
    </div>
    <div class="md:container max-md:ms-5 mb-5 md:mb-10"
         v-if="!themeStore.minimize_ui">
        <PopularProducts/>
    </div>
    <div class="mb-10"
         v-if="!themeStore.minimize_ui">
        <ChooseUs/>
    </div>
    <div class="mb-10" v-if="!themeStore.minimize_ui">
        <Feedbacks/>
    </div>
    <div class="container" v-if="!themeStore.minimize_ui">
        <FaqComponent title="Частые вопросы"
                      subtitle="Остались вопросы? Наши менеджеры всегда готовы ответить!"
                      :items="homeFaqItems"
                      schema-id="schema-home-faq-jsonld"/>
    </div>
</template>

<script>
import {useThemeStore} from "@/js/store/ThemeStore.js";
import Feedbacks from "@js/components/Sections/Feedbacks/Feedbacks.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import HomeCatalogNavigation from "@js/components/Sections/Home/HomeCatalogNavigation.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import FaqComponent from "@js/components/Faq/FaqComponent.vue";
import HomeSlider from "@js/components/Sections/PageComponent/Home/HomeSlider.vue";
import PopularProducts from "@js/components/Sections/Sliders/PopularProducts.vue";
import SearchByPhotoBanner from "@js/components/ImageSearch/SearchByPhotoBanner.vue";
import PopularProductBanners from "@js/components/Sections/Home/PopularProductBanners.vue";
import ChooseUs from "@js/components/Sections/Home/ChooseUs.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import MobileCategoriesNav from "@js/components/Sections/Home/MobileCategoriesNav.vue";

export default {
    name: 'Home',
    props: {
    },
    components: {
        MobileCategoriesNav,
        OnlyMobile,
        ChooseUs,
        PopularProductBanners,
        SearchByPhotoBanner,
        PopularProducts,
        HomeSlider,
        FaqComponent,
        MobileTopBar,
        HomeCatalogNavigation,
        OnlyDesktop,
        Feedbacks,
    },
    data() {
        return {
            is_hovered: false,
            isMounted: false,
            homeFaqItems: [
                {
                    question: 'Какие строительные материалы можно заказать в ФУЛЛ СТРОЙ?',
                    answer: 'У нас можно заказать ЖБИ, бетонные смеси, пиломатериалы, тротуарную плитку, нерудные материалы и строительные конструкции. Поможем подобрать позиции под задачу и рассчитать нужный объем.',
                },
                {
                    question: 'Вы работаете только с оптовыми заказами?',
                    answer: 'Основное направление - оптовые поставки для строительных объектов, подрядчиков и организаций. Но по отдельным позициям можно обсудить и меньший объем. Лучше оставить заявку - менеджер проверит наличие и условия поставки.',
                },
                {
                    question: 'Как оформить заказ на материалы?',
                    answer: 'Вы можете выбрать нужные товары на сайте и отправить заявку. После этого менеджер свяжется с вами, уточнит объем, адрес доставки, сроки и подготовит расчет по заказу.',
                },
                {
                    question: 'Как рассчитывается стоимость заказа?',
                    answer: 'Цена зависит от категории материала, объема, характеристик, наличия на складе и условий доставки. После уточнения деталей мы подготовим расчет и согласуем итоговую стоимость до отгрузки.',
                },
                {
                    question: 'Можно ли заказать доставку на объект?',
                    answer: 'Да, организуем доставку материалов на строительные объекты. При оформлении заказа нужно указать адрес, удобное время приемки и особенности подъезда для транспорта.',
                },
            ]
        };
    },
    setup() {
        const themeStore = useThemeStore()

        return {themeStore}
    },
    mounted() {
        this.isMounted = true
    }
};
</script>

<style lang="scss">

</style>
